import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/back-button.svg")